var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBluearrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "24px",
    height: "42px",
    viewBox: "0 0 24 42",
    enableBackground: "new 0 0 24 42",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#0A84FE",
    d: "M20.997,42c-0.768,0-1.536-0.293-2.122-0.881L0.88,23.121C0.316,22.559,0,21.794,0,20.998 s0.316-1.56,0.88-2.124L18.871,0.879c1.173-1.172,3.072-1.172,4.245,0s1.173,3.074,0,4.247L7.248,20.998L23.12,36.873 c1.173,1.172,1.173,3.074,0,4.246C22.534,41.707,21.766,42,20.997,42z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBluearrow);
export default __webpack_public_path__ + "static/media/bluearrow.464f52e09ca8afbdb030e2a4890c236a.svg";
export { ForwardRef as ReactComponent };